var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['wysiwyg', _vm.mergeProps.size ? `typo--${_vm.mergeProps.size}` : null],domProps:{"innerHTML":_vm._s(_vm.mergeProps.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }